import React, { useState } from "react";
import styles from "./ItineraryMap.module.scss";
import {
  MapBox as AppMapBox,
  ItineraryDetails as ScrollableTabsAndCards,
} from "@/components/Mapbox";
import { Coords, TripItinerary } from "@/fetch/inventory";
import Typography from "../Typography";

type Props = {
  id: string;
  itinerary: TripItinerary[];
  itineraryTeaser?: string;
  map: Coords;
  title: string;
};
const ItineraryMap = ({
  id,
  title,
  itinerary,
  itineraryTeaser,
  map,
}: Props) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const parsedItineraries = itinerary.map((it, index) => {
    let location = it.location?.[0];

    if (!location) {
      location = {
        m_lat:
          index === 0
            ? map.lat.toString()
            : itinerary[index - 1].location?.[0]?.m_lat ?? "",
        m_lng:
          index === 0
            ? map.lng.toString()
            : itinerary[index - 1].location?.[0]?.m_lng ?? "",
        forceOverview: true,
        ...(index !== 0
          ? {
              zoom: itinerary[index - 1].location?.[0]?.m_zoom_level,
              city: itinerary[index - 1].location?.[0]?.city,
              country: itinerary[index - 1].location?.[0]?.country,
              region: itinerary[index - 1].location?.[0]?.region,
            }
          : {}),
      };
    }

    return {
      ...it,
      location: [location],
    };
  });

  const onItinerarySelected = (itineraryIndex: number) => {
    setSelectedIndex(itineraryIndex);
  };

  const hasNoLocation = itinerary.every((i) => !i.location);

  return (
    <div className={styles.root}>
      <div>
        <Typography
          variant="h6"
          color="text.secondary"
          className={styles.title}
        >
          {title}
        </Typography>
        <div
          className={styles.itinerary}
          dangerouslySetInnerHTML={{ __html: itineraryTeaser || "" }}
        ></div>
      </div>
      <div className={styles.container}>
        <div>
          <ScrollableTabsAndCards
            itinerary={itinerary}
            onItinerarySelected={onItinerarySelected}
            selectedIndex={selectedIndex}
          />
        </div>
        <div className={styles.mapContainer}>
          {!hasNoLocation && (
            <AppMapBox
              itineries={parsedItineraries}
              selectedIndex={selectedIndex}
              tripLocation={map}
              setSelectedIndex={onItinerarySelected}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default ItineraryMap;
